// extracted by mini-css-extract-plugin
module.exports = {"bold":"regions-list-module__bold___1VIcV"};